import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function SubHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const currentPage = location.pathname.substring(1) || 'home';

  const categories = [
    { id: 'appartements', label: 'Appartements', available: true },
    { id: 'villas', label: 'Villas', available: false },
    { id: 'logements-atypiques', label: 'Logements Atypiques', available: false },
    { id: 'voitures', label: 'Voitures', available: false },
    { id: 'scooters', label: 'Scooters', available: false },
    { id: 'activites', label: 'Activités', available: false },
  ];

  return (
    <div className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
      <div className="container mx-auto px-4">
        <div className="hidden md:flex items-center justify-center space-x-1 py-3">
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => category.available && navigate(`/${category.id}`)}
              disabled={!category.available}
              className={`px-4 py-2 rounded-lg transition font-medium flex items-center gap-2 ${
                !category.available
                  ? 'text-gray-400 cursor-not-allowed'
                  : currentPage === category.id
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-700 hover:bg-white hover:shadow'
              }`}
            >
              {category.label}
              {!category.available && (
                <span className="text-xs bg-orange-100 text-orange-600 px-2 py-0.5 rounded-full font-semibold">
                  Bientôt
                </span>
              )}
            </button>
          ))}
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="flex items-center justify-between w-full py-3 text-gray-700"
          >
            <span className="font-medium">Catégories</span>
            {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>

          {isMenuOpen && (
            <div className="pb-3 space-y-1">
              {categories.map(category => (
                <button
                  key={category.id}
                  onClick={() => {
                    if (category.available) {
                      navigate(`/${category.id}`);
                      setIsMenuOpen(false);
                    }
                  }}
                  disabled={!category.available}
                  className={`flex items-center justify-between w-full text-left px-4 py-2 rounded-lg transition ${
                    !category.available
                      ? 'text-gray-400 cursor-not-allowed'
                      : currentPage === category.id
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-700 hover:bg-white'
                  }`}
                >
                  <span>{category.label}</span>
                  {!category.available && (
                    <span className="text-xs bg-orange-100 text-orange-600 px-2 py-0.5 rounded-full font-semibold">
                      Bientôt
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
